import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import DetalhesPedido from '../../components/DetalhesPedido';
import Modal from '../../components/Modal';
import {
  formataDataCompleta,
  formataDataSemHora,
  isData,
  moeda,
} from '../../components/funcoes';
import { Container, Stack, Table } from 'rsuite';
import { ContainerData } from './styles';
import { useAuth } from '../../hooks/auth';
import { useCustomTheme } from '../../hooks/useCustomTheme';
import { ContentHeader } from '../../components/ContentHeader';
import DuvidasButton from '../../components/DuvidasButton';
import { CustomInput } from '../../components/CustomInput';
import { CustomButton } from '../../components/CustomButton';
import { CustomHeaderCell } from '../../components/CustomHeaderCell';
import { CustomCell } from '../../components/CustomCell';
import { FaCalendarAlt } from 'react-icons/fa';

const { Column } = Table;

let data = new Date();
data = `${data.getFullYear()}-${data.getMonth() + 1}-${data.getDate()}`;

export default function Agendamento() {
  const { id_empresa } = useAuth();
  const [loading, setLoading] = useState(true);
  const [agendamentos, setAgendamentos] = useState([]);
  const [entregadores, setEntregadores] = useState([]);
  const [pedidoSelecionado, setPedidoSelecionado] = useState({});
  const [open, setOpen] = useState(false);
  const [dataInicial, setDataInicial] = useState(data);
  const [dataFinal, setDataFinal] = useState(data);
  const { theme } = useCustomTheme();

  const atualizar = async () => {
    setLoading(true);
    await api.get(`entregador/listar/${id_empresa}`).then((res) => {
      setEntregadores(res.data);
      setLoading(false);
    });
  };

  const consultarAgendamentos = async () => {
    setLoading(true);
    let busca = '';
    if (isData(dataInicial) && isData(dataFinal)) {
      busca = `AND DataAgendamento BETWEEN '${dataInicial} 00:00:00' and '${dataFinal} 23:59:59'`;
    } else if (!isData(dataFinal)) {
      const date = new Date().getDate();
      const month = new Date().getMonth();
      const year = new Date().getFullYear();

      const result =
        String(year) + '-' + String(month + 1) + '-' + String(date);
      busca = `AND DataAgendamento BETWEEN '${dataInicial} 00:00:00' and '${result} 23:59:59'`;
    }

    await api
      .post('pedido/listarAgendamentos', {
        IdEmpresa: id_empresa,
        Consulta: busca,
      })
      .then((res) => {
        setAgendamentos(res.data);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    consultarAgendamentos();
  }, [dataInicial, dataFinal]);

  const verTodosAgendamentos = () => {
    setDataInicial('');
    setDataFinal('');
  };

  const abrirDados = (pedido) => {
    setPedidoSelecionado(pedido);
    setOpen(true);
  };

  useEffect(() => {
    atualizar();
  }, []);

  return (
    <Container
      style={{
        padding: '10px',
        height: 'calc(100vh - 60px)',
        backgroundColor: theme.colors.background,
      }}
    >
      <ContentHeader
        title="Agendamentos"
        subtitle="Gerencie os agendamentos da sua empresa"
        icon={FaCalendarAlt}
        thirdComponent={
          <Stack style={{ display: 'flex', alignItems: 'flex-end' }}>
            <ContainerData style={{ display: 'flex', flexDirection: 'column' }}>
              <label htmlFor="dataInicio" style={{ color: theme.colors.text }}>
                Data Inicial{' '}
              </label>
              <CustomInput
                type="date"
                value={dataInicial}
                onChange={setDataInicial}
              />
            </ContainerData>
            <ContainerData style={{ display: 'flex', flexDirection: 'column' }}>
              <label htmlFor="dataInicio" style={{ color: theme.colors.text }}>
                Data Final{' '}
              </label>
              <CustomInput
                type="date"
                value={dataFinal}
                onChange={setDataFinal}
              />
            </ContainerData>

            <CustomButton
              appearance="primary"
              onClick={() => verTodosAgendamentos()}
              style={{ marginBottom: '1px' }}
            >
              Ver Todos
            </CustomButton>
            <DuvidasButton tela="agendamento" />
          </Stack>
        }
      />

      <Table
        height={window.innerHeight - 60 - 110}
        data={agendamentos}
        bordered={true}
        loading={loading}
        style={{
          overflowY: 'auto',
          borderColor: theme.colors.backgroundSecondary,
          backgroundColor: theme.colors.backgroundSecondary,
          color: theme.colors.textSecondary,
        }}
        locale={{
          emptyMessage: 'Nenhum agendamento encontrado',
          loading: 'Carregando...',
        }}
      >
        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          flexGrow={1}
          fixed
        >
          <CustomHeaderCell>Código</CustomHeaderCell>
          <CustomCell dataKey="Codigo" />
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          flexGrow={1}
        >
          <CustomHeaderCell>Data Pedido</CustomHeaderCell>
          <CustomCell>
              {(rowData) => (
                <text>
                  {formataDataSemHora(rowData.DataPedido)}
                </text>
              )}
          </CustomCell>
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          flexGrow={1}
        >
          <CustomHeaderCell>Data Agendada</CustomHeaderCell>
          <CustomCell>
            {(rowData) => (
              <text>
                {formataDataCompleta(rowData.DataAgendamento)}
              </text>
            )}
          </CustomCell>
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          flexGrow={1}
        >
          <CustomHeaderCell>Tipo Entrega</CustomHeaderCell>
          <CustomCell>
            {(rowData) => (
              <text>
                {rowData.TipoEntrega === 'AG' ? 'ENTREGA' : 'RETIRAR NA LOJA'}
              </text>
            )}
          </CustomCell>
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
        >
          <CustomHeaderCell>Valor Total</CustomHeaderCell>

          <CustomCell>
            {(rowData) => <text>{moeda(rowData.ValorTotal)}</text>}
          </CustomCell>
        </Column>
        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          fixed="right"
        >
          <CustomHeaderCell>Opções</CustomHeaderCell>
          <CustomCell>
            {(rowData) => (
              <>
                <span>
                  <CustomButton
                    color="#0043ff"
                    appearance="ghost"
                    size="xs"
                    onClick={() => {
                      abrirDados(rowData);
                    }}
                  >
                    Editar
                  </CustomButton>
                </span>
              </>
            )}
          </CustomCell>
        </Column>
      </Table>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        pedido={pedidoSelecionado}
        refresh={consultarAgendamentos}
        title={`Detalhes do pedido - ${pedidoSelecionado.Codigo}`}
      >
        <DetalhesPedido
          onClose={() => setOpen(false)}
          pedido={pedidoSelecionado}
          entregadores={entregadores}
          refresh={consultarAgendamentos}
          formatarData={formataDataCompleta}
        />
      </Modal>
    </Container>
  );
}
